import { FETCH_ORDER_HISTORY_SUCCESS, CLEAR_ORDER_HISTORY } from '../constants/ActionTypes'
import type { OrderHistoryAction } from '../constants/ActionTypes'
import type { RawOrderHistory, OrderHistoryState } from 'app/types/orders'

export default function orderHistory(state: OrderHistoryState = undefined, action: OrderHistoryAction) {
    switch (action.type) {
        case CLEAR_ORDER_HISTORY: {
            const key = `${action.payload}Orders`
            return {
                ...(state || {}),
                [key]: undefined,
            }
        }
        case FETCH_ORDER_HISTORY_SUCCESS: {
            const { category, clearState, data } = action.payload as { category: 'past' | 'recent', clearState: boolean, data: RawOrderHistory }
            const key = `${category}Orders`
            const currentOrders = state && state[key] ? state[key].items : []
            const { pendingOrders, orders, ...recordSetDetails } = data || {}
            return {
                ...(state || {}),
                [key]: {
                    ...recordSetDetails,
                    items: [...(clearState ? [] : currentOrders), orders],
                    ...(pendingOrders && {
                        pendingItems: [pendingOrders],
                    }),
                },
            }
        }

        default:
            return state
    }
}
